
import { Component, Vue } from 'vue-property-decorator';
import { regular } from '@/const/regular';
import { createCompany } from '../../api/company';
import { UserModule } from '../../store/modules/user';
import { getUserToken, setUserToken, setLocUserToken } from '@/utils/cookies';

@Component({
  name: 'CompanyCreate',
  components: {

  }
})
export default class extends Vue {
  private repairType = '1'
  private isActive = false;
  private selectVer = true;
  private typeInner = 1
  private typeProfessional = 1
  private InnerTypes = ['其他', '院校', '医院', '车站', '党政机关', '物业','连锁门店'];
  private RepairTypes = ['服务方', '生产厂商'];
  private formCreate = {
    name: '',
    team: '',
    user: '',
    mobile: '',
    telephone: ''
  }
  private regular = regular;
  private rules = {
    name: [
      { required: true, message: '请输入5-30位由数字、字母、中文组成的名称', trigger: 'blur' },
      { pattern: regular.companyName.pattern, message: '请输入5-30位由数字、字母、中文组成的名称', trigger: 'blur' }
    ],
    mobile: [
      { pattern: regular.mobile.pattern, message: '请输入正确格式的手机号码', trigger: 'blur' }
    ],
    telephone: [
      { pattern: regular.phone.pattern, message: '请输入正确格式的电话号码', trigger: 'blur' }
    ]
  }
  private goBack() {
    this.$router.go(-1);
  }
  private nextHandle() {
    this.isActive = true;
    this.selectVer = false;
  }
  private finishpreHandle() {
    this.selectVer = true;
    this.isActive = false;
  }
  private finishHandle(formName: any) {
    let that = this;
    (this.$refs[formName]as any).validate((valid: any) => {
      if (valid) {
        const comapnyTypeId = parseInt(this.repairType) === 1 ? this.typeInner : this.typeProfessional;
        const comapnyTypeName = parseInt(this.repairType) === 1 ? this.InnerTypes[this.typeInner] : this.RepairTypes[this.typeProfessional - 1];
        const params = {
          user_id: UserModule.getUserId,
          name: this.formCreate.name,
          short_name: '',
          manager: this.formCreate.user,
          mobile: this.formCreate.mobile,
          phone_num: this.formCreate.telephone,
          company_type_id: comapnyTypeId,
          company_type_name: comapnyTypeName,
          vip_level: this.repairType
        };
        createCompany(params).then((res:any) => {
          this.showSecussMsg(res.msg);
          if (res.data && res.data.company && res.data.company.length > 0) {
            let token:any = getUserToken();
            if (typeof token !== 'object') {
              token = JSON.parse(token as string);
            }
            token.company_id = res.data.company[0].id;
            setUserToken(JSON.stringify(token));
            setLocUserToken('');
            that.$router.push({
              path: '/Index'
            });
          } else {
            that.goBack();
          }

          // TODO: 切换公司并返回主页
        }).catch(err => {
          this.showErrorMsg(err.msg);
        });
      } else {
        return false;
      }
    });
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSecussMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'success'
    });
  }
}
